(function($){
    'use strict';

    var $listSort = $('.list-sort'),
        $title = $listSort.find('.list-sort__title'),
        $titleButton = $title.find('button'),
        $selectedOrder = $listSort.find('.list-sort__selected'),
        $sortLinks = $listSort.find('.list-sort__options').find('a');

        $titleButton.click(function(event){
            event.preventDefault();
            if(!$listSort.hasClass('active')){
                $listSort.addClass('active');
            }else {
                $listSort.removeClass('active');
            }
        });

        // set the selected option
        $sortLinks.each(function(event){

            var $cur = $(this);
                $cur.click(function(){
                    var $val = $(this).attr('data-value');

                    if($val != undefined){
                        $sortLinks.removeClass('active');
                        $selectedOrder.find('.list-sort__selected-value').text(capitalizeFirstLetter($val));
                        $listSort.removeClass('active');
                        $(this).addClass('active');
                    }
                });

        });

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

}(jQuery));